<mat-grid-list cols="1" gutterSize="20px" rowHeight="fit" style="height:100%">
  <mat-grid-tile>
    <div class="dashboard-tile">
      <div class="tile-header">
        <div *ngIf="_assessment?.id" class="tile-header-title">Update Assessment Template <span class="text-primary">{{_assessment.name}}</span></div>
        <div *ngIf="!_assessment?.id" class="tile-header-title">New Assessment Template</div>
      </div>
      <div class="tile-content">
        <form [formGroup]="assessmentForm" style="width:100%; margin: 20px 0px;">
          <div class="formFieldList">
            <mat-form-field>
              <input matInput placeholder="Name" formControlName="assessmentName" required>
            </mat-form-field>
            <mat-form-field>
              <mat-select placeholder="Type" formControlName="assessmentType" required>
                <mat-option *ngFor="let type of availableTypes" [value]="type">{{type}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <textarea matInput placeholder="Assessment Description" formControlName="assessmentDescription" required style="min-height:100px;"></textarea>
            </mat-form-field>
            <mat-form-field>
              <textarea matInput placeholder="Assessment JSON" formControlName="assessmentJson" required style="min-height:350px;"></textarea>
            </mat-form-field>          
            <div fxLayout="row wrap" fxLayoutGap="20px">
              <button [disabled]="assessmentForm.invalid" mat-raised-button type="submit" color="primary" (click)="saveAssessment()">Save</button>
              <button mat-raised-button type="button" color="primary" (click)="cancelAssessment()">Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </mat-grid-tile>
</mat-grid-list>
